import React from 'react';
import { useSnackbarContext } from '../../../contexts/Snackbar';
import { makeStyles } from '@material-ui/core/styles';
import { Field } from 'formik';
import { TextField } from 'formik-material-ui';
import { updateCompany } from '../../API/company';
import startCase from 'lodash.startcase';
import messages from '../../../messages';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import SaveIcon from '@material-ui/icons/Save';

const useStyles = makeStyles(() => ({
  field: {
    width: 200,
    '& .MuiInputBase-root': {
      width: 200,
    },
    fontSize: 'inherit',
    border: 'none',
    textAlign: 'center',
  },
  saveButton: {
    position: 'absolute',
    right: 0,
  },
  typographyTop: {
    padding: 0,
    marginTop: '20px',
  },
  typographyBottom: {
    marginBottom: '20px',
  },
}));

export default function ApplicationEditDetails({
  business,
  setBusiness,
  setLoading,
  setEditClose,
  values,
}) {
  const classes = useStyles();
  const snackbar = useSnackbarContext();

  const handleButtonClick = async () => {
    if (values.businessName === '')
      snackbar.show('Business Name is required', 'error');
    else {
      try {
        if (business.name !== values.businessName) {
          setLoading(true);
          await updateCompany({
            name: values.businessName,
          });
          setBusiness({
            ...business,
            name: values.businessName,
          });
        }
        setEditClose(false);
      } catch (error) {
        snackbar.show(messages.general.saveError, 'error');
      }
    }
    setLoading(false);
  };

  return (
    <>
      <div>
        <IconButton
          onClick={handleButtonClick}
          aria-label="edit"
          className={classes.saveButton}
        >
          <SaveIcon />
        </IconButton>
      </div>
      <Typography
        align="justify"
        variant="h6"
        className={classes.typographyTop}
      >
        <b>Business Name : </b>
        <Field
          name="businessName"
          placeholder="Business Name"
          component={TextField}
          type="text"
          className={classes.field}
        />
      </Typography>

      <Typography variant="h6" align="justify">
        <b>Selling model : </b> {business?.sellerType}
      </Typography>
      <Typography
        align="justify"
        variant="h6"
        className={classes.typographyBottom}
      >
        <b>Primary platform : </b>
        {startCase(business.sellerStore)}
      </Typography>
    </>
  );
}
